import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

export const faqCreate = (params = '') => Http.post('/faq', params)
export const faqsList = (params = '') => Http.get(`/faq${serialize(params)}`)
export const faqByID = (params = '') => Http.get(`/faq/${params}`)
export const faqUpdate = (params = '') => Http.put(`/faq/${params.id}`, params)
export const faqDestroy = (params = '') => Http.delete(`/faq/${params.id}`)
